import React from 'react';
import PropTypes from 'prop-types';
import { withConditionalFeatures } from '@americanexpress/conditional-features';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Accordion, AccordionContent } from '@americanexpress/dls-react';
import { useMediaBreakpoint } from '@americanexpress/consumer-travel-base';
import { hasTravelCreditTabRule } from '../../constants/featureRulesConstants';
import TravelCreditTab from './TravelCreditTab';
import TravelCreditTabButton from './TravelCreditTabButton';
import {
  setTravelCreditTabClosed,
  setTravelCreditTabOpen,
} from '../../ducks/homeDuck';
import { getShowTravelCreditTab } from '../../selectors/getHomeSelectors';

const TravelCreditTabButtonWrapper = ({
  hasTravelCreditTab,
  selectedAccountData,
}) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const isMobile = useMediaBreakpoint('sm-down');

  const isTravelCreditTabOpen = useSelector(getShowTravelCreditTab);
  const travelCreditData = selectedAccountData?.travelCredit;

  const isTravelCreditUnavailable = !hasTravelCreditTab
    || !travelCreditData
    || (typeof travelCreditData === 'object' && Object.keys(travelCreditData).length === 0)
    || (Array.isArray(travelCreditData) && travelCreditData.length === 0);
  if (isTravelCreditUnavailable) {
    return null;
  }

  const buttonLabel = formatMessage({
    id: `travelCreditTab.button.${isTravelCreditTabOpen ? 'close' : 'show'}`,
  });
  const analyticsInfo = {
    element: 'hp-travelCreditTab',
    detail: `${isTravelCreditTabOpen ? 'close' : 'show'}TravelCredit${isMobile ? 'Mobile' : ''}`,
  };

  const onClick = () => {
    if (isTravelCreditTabOpen) {
      return dispatch(setTravelCreditTabClosed);
    }
    return dispatch(setTravelCreditTabOpen);
  };

  if (isMobile) {
    return (
      <Accordion
        openPanelIds={
          isTravelCreditTabOpen ? ['showTravelCreditTabButtonMobile'] : []
        }
      >
        <div className="text-align-center pad-2-b">
          <TravelCreditTabButton
            id="showTravelCreditTabButtonMobile"
            aria-expanded={isTravelCreditTabOpen}
            onClick={onClick}
            buttonLabel={buttonLabel}
            analyticsInfo={analyticsInfo}
          />
        </div>
        <AccordionContent aria-labelledby="showTravelCreditTabButtonMobile">
          <div className="border-tb">
            <TravelCreditTab
              isMobile={true}
              selectedAccountData={selectedAccountData}
            />
          </div>
        </AccordionContent>
      </Accordion>
    );
  }
  return (
    <div className="border-lr text-align-center pad-2-b">
      <TravelCreditTabButton
        id="showTravelCreditTabButton"
        buttonLabel={buttonLabel}
        onClick={onClick}
        analyticsInfo={analyticsInfo}
        aria-expanded={isTravelCreditTabOpen}
      />
    </div>
  );
};

TravelCreditTabButtonWrapper.propTypes = {
  hasTravelCreditTab: PropTypes.bool.isRequired,
  selectedAccountData: PropTypes.shape({
    displayAccountNumber: PropTypes.string,
    cardArtCdnLink: PropTypes.string,
    travelCredit: PropTypes.shape({
      name: PropTypes.string,
      description: PropTypes.string,
      expiry: PropTypes.string,
    }),
  }),
};

TravelCreditTabButtonWrapper.defaultProps = {
  selectedAccountData: {},
};

export { TravelCreditTabButtonWrapper as TestableTravelCreditTabButtonWrapper };

export const mapFeaturesToProps = {
  hasTravelCreditTab: hasTravelCreditTabRule,
};

export default withConditionalFeatures({ mapFeaturesToProps })(TravelCreditTabButtonWrapper);
